import React, { FC } from "react";
import styled from "@emotion/styled";
import { Col, Row } from "antd";
import { GetFactoryOverviewCompleteData } from "services/interface";


interface ContentBodyProps {
  data: GetFactoryOverviewCompleteData | undefined 
};

const ContentBody:FC<ContentBodyProps> = ({ data }) => {
  return (
    <WeapperCard>
    <Row gutter={[16,16]} style={{ marginTop: 20 }}  >
      <Col span={8} >
        <WrapperContentAgent>
          <WrapperTextContent>
            <TextAmount>{data?.comp_count}</TextAmount>
            <TextPercent>{data?.percent}</TextPercent>
          </WrapperTextContent>
        </WrapperContentAgent>
      </Col>
    </Row>
    </WeapperCard>
  );
};

export default ContentBody;

const WrapperContentAgent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;


const WrapperTextContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: auto;
  border-radius: 0px;
  padding: 0px 0px 0px 10px;
`;

const TextAmount = styled.p`
  font-size: 36px;
  font-weight: 500;
  background-color: #ffffff;
`;



const TextPercent = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #00b300;
  margin-left: 5px;
`;

const WeapperCard = styled.div`
  display: flex;
  height: 62px;
`;